import { Extension } from "@tiptap/core";
import { Plugin, PluginKey } from "@tiptap/pm/state";

// Emoticon to emoji mappings
const emoticonMap = {
  ":)": "😊",
  ":-)": "😊",
  ":(": "😢",
  ":-(": "😢",
  ":D": "😃",
  ":-D": "😃",
  ";)": "😉",
  ";-)": "😉",
  ":P": "😛",
  ":-P": "😛",
  ":p": "😛",
  ":-p": "😛",
  "<3": "❤️",
  ":o": "😮",
  ":-o": "😮",
  ":O": "😮",
  ":-O": "😮",
  xD: "😆",
  XD: "😆",
  ":/": "😕",
  ":-/": "😕",
  "B)": "😎",
  "B-)": "😎",
  ":*": "😘",
  ":-*": "😘",
  "^_^": "😊",
  o_o: "😳",
  O_O: "😳",
  ">:(": "😠",
  ">:-(": "😠",
  ":'(": "😢",
  ":')": "😂",
  ":|": "😐",
  ":-|": "😐",
};

// Create regex pattern that matches all emoticons
// Sort by length descending to match longer patterns first (e.g., ":-)" before ":)")
const emoticonPatterns = Object.keys(emoticonMap)
  .sort((a, b) => b.length - a.length)
  .map((emoticon) => emoticon.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))
  .join("|");

const emoticonRegex = new RegExp(`(${emoticonPatterns})(?=\\s|$)`, "g");

// Sort emoticons by length (longest first) to check longer patterns first
const sortedEmoticons = Object.entries(emoticonMap).sort(
  ([a], [b]) => b.length - a.length,
);

export const EmoticonReplacer = Extension.create({
  name: "emoticonReplacer",

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("emoticonReplacer"),

        props: {
          handleTextInput(view, from, to, text) {
            const { state, dispatch } = view;

            // Don't trigger on Enter/newline
            if (text === "\n") return false;

            // Get text before cursor including what was just typed
            const $pos = state.doc.resolve(from);
            const textBefore =
              $pos.parent.textContent.slice(0, $pos.parentOffset) + text;

            // Check each emoticon (longest first) to see if text ends with it
            for (const [emoticon, emoji] of sortedEmoticons) {
              if (textBefore.endsWith(emoticon)) {
                // Found a match - replace it
                const startPos = from - emoticon.length + text.length;

                // Replace the emoticon with emoji and add a space
                const tr = state.tr;
                tr.delete(startPos, to);
                tr.insertText(emoji + " ", startPos);
                dispatch(tr);

                return true;
              }
            }

            return false;
          },
        },
      }),
    ];
  },
});
